export default "__VITE_ASSET__b90ceb24__"